import { Input } from 'antd'
import PropTypes from 'prop-types'
import './TextAreaCommon.scss'

const { TextArea } = Input

export const TextAreaCommon = ({
	onChange,
	placeholder,
	rows = 5,
	value,
	...rest
}) => {
	const handleChange = e => {
		onChange && onChange(e.target.value)
	}

	return (
		<TextArea
			placeholder={placeholder}
			onChange={handleChange}
			rows={rows}
			value={value}
			{...rest}
		/>
	)
}

TextAreaCommon.propTypes = {
	onChange: PropTypes.func,
	placeholder: PropTypes.string,
	rows: PropTypes.number,
	value: PropTypes.any,
}
